import { CustomComponentProps, PostFormObject } from "utils/types/generalTypes";
import PostForm from "./PostForm";

export type PostFormGroupProps = CustomComponentProps & {
    postGroup: PostFormObject[];
};

const PostFormGroup = ({ postGroup, className, style }: PostFormGroupProps) => {
    return (
        <div
            className={`control ${className}`}
            id="post-modal-body"
            style={style}
        >
            <form id="post-form" encType="multipart/form-data">
                {postGroup.map((post) => (
                    <PostForm key={post.id} postId={post.id} post={post} />
                ))}
            </form>
        </div>
    );
};

export default PostFormGroup;
